<template>

<app-view-list-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

	<div class="counts is-empty" v-if="!max"></div>

	<div class="counts" v-if="max">

		<div v-for="(count, index) in value" :key="index" class="counts-bar" v-tooltip="tooltip(count, index)">

			<div class="counts-bar-percent" :style="{height: count.percent + '%', backgroundColor: color}" :class="{'is-value': count.value}"></div>

		</div>

	</div>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

    computed: {

        color: function() {

            if(this.item.game) {

				return 'rgba(' + ((this.item.game.color !== '0') ? this.item.game.color : '134, 134, 134') + ')'

			} else {

				return 'rgba(134, 134, 134)'

			}

        },

        max: function() {

            return this.$_.max(this.item.counts)

        },

		value: function() {

            var counts = []

			this.$_.each(this.item.counts, function(value, count) {

				count++
				var text = (count === this.item.counts.length) ? (count + this.offsetFinal - 1).toString() + '+' : (count + this.offsetFinal - 1).toString()

				counts.push({
					percent: (100 / this.max) * value,
					value: value,
					text: text
				})

			}.bind(this))

            return counts

		}

    },

	methods: {

		tooltip: function(count, index) {

			return count.text + this.$util.plural('player', index + this.offsetFinal) + '<small>' + count.value + this.$util.plural('play', count.value) + '</small>'

		}

    }

}

</script>

<style scoped>

.counts {
	height: 32px;
	display: flex;
	flex-direction: row;
	justify-content: center;
}

.counts.is-empty {
	font-size: 14px;
	font-weight: 400;
	color: #ccc;
	line-height: 32px;
}

.counts-bar {
	height: 32px;
	width: 8px;
	margin-right: 1px;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	background-color: #efefef;
	border-radius: 4px;
}

.counts-bar:last-child {
	margin-right: 0px;
}

.counts-bar-percent {
	width: 8px;
	border-radius: 4px;
}

.counts-bar-percent.is-value {
	min-height: 8px;
}

</style>
